
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import moment from 'moment';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impfung from '@/types/Impfung';
    import Patient from '@/types/Patient';
    import { ValidationRules } from '@/store/types';
    import { confirmSwal } from '@/helper/swals';
    import {VForm, createAutocompleteFilter, VDatePickerInput} from '@/types/Components';
    import Diagnose from '@/types/Diagnose';
    import DatePickerInput from '@/components/DatePickerInput.vue';
    import {DiagnosenFilter, LoadDiagnosenPayload} from '@/store/diagnosen';
    import _ from 'lodash';
    import DiagnosenDetail from '@/components/Diagnosen/DiagnosenDetail.vue';

    @Component({
        components: {
            EingetragenAmVom,
            DatePickerInput,
            DiagnosenDetail
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('session', ['arzt', 'abrechnungLeistung']),
            ...mapState('patient', ['patientData', 'loaders']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('diagnosen', ['diagnosen']),
            ...mapState('diagnosen', { diagnosenLoaders: 'loaders' }),
            ...mapGetters('personen', ['getPersonen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
            ...mapState('diagnosen', ['dialogs']),
        },
        methods: {
            ...mapActions('patient', ['createDiagnoseneintrag', 'deleteDiagnoseneintrag']),
            ...mapActions('diagnosen', ['loadDiagnosen']),
            ...mapMutations('patient', ['setDialogDiagnose']),
            ...mapMutations('session', ['setSelectedArzt']),
            ...mapMutations('diagnosen', ['setDialogsDetail']),
        },
    })
    export default class DiagnoseneintragDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Impfung;

        public $refs!: {
            form: VForm;
            diagnosedatum: VDatePickerInput
        };

        public rules!: ValidationRules;
        public patientData!: Patient;
        public impfstelle_id!: number;
        public loadDiagnosen!: (payload?: LoadDiagnosenPayload) => void;
        public formatDate!: (input: string | null) => string | null;
        public parseDate!: (input: string | null) => string | null;
        public createDiagnoseneintrag!: (data: Impfung) => void;
        public deleteDiagnoseneintrag!: (data: Impfung) => void;
        public setDialogDiagnose!: (visible: boolean) => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public diagnose = new Diagnose();

        public data = new Impfung();
        public diagnosen!: any;
        public arzt!: number | null;
        public search = '';

        public filter: DiagnosenFilter = {
            gueltig: 'j',
        };

        public readonly diagnosenFilter = createAutocompleteFilter<Diagnose>('diagnose', 'gueltig');

        public get isNew(): boolean {
            return this.data.patimpfung_id === null;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (!visible) return;

            this.data = new Impfung(this.value);
            this.loadDiagnosen({ filter: this.filter});

            if (this.isNew) {
                this.data.anzahl = 1;
                this.data.patnr = this.patientData.patnr;
                this.data.impfdatum = moment().format('YYYY-MM-DD');
                this.data.impfstelle_id = this.impfstelle_id;
                if (this.data.diagnose) {
                    this.data.diagnose.patnr = this.patientData.patnr;
                }

                if (this.arzt) {
                    this.data.person_id_durchf = this.arzt;
                }
            } else {
                this.data.diagnose.diagnose_id = Number(this.data.patdiagnose_diagnose_id);
                this.data.diagnose.hauptdiagnose = this.data.patdiagnose_hauptdiagnose;
                this.data.diagnose.haupt_patdiagnose_id = this.data.patdiagnose_haupt_patdiagnose_id;
                this.data.diagnose.immunsupression = this.data.patdiagnose_immunsupression;
                this.data.diagnose.patnr = this.patientData.patnr;
                this.data.diagnose.patdiagnose_id = this.data.patdiagnose_id;
                this.data.diagnose.diagnosedatum = this.data.impfdatum;
                this.data.diagnose.nebendiagnosen = this.data.nebendiagnosen;
            }

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }

        public onClickSave(): void {
            if (!this.$refs.form.validate() || this.impfdatumErrorMessages.length > 0) {
                return;
            }

            this.createDiagnoseneintrag(this.data);
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Diagnoseneintrag endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteDiagnoseneintrag(this.data);
                    }
                });
        }

        public close(): void {
            this.$emit('close');
            this.setDialogDiagnose(false);
        }

        public impfdatumMenu = false;
        public impfdatumFormatted: string | null = null;
        public impfdatumErrorMessages: string[] = [];

        @Watch('data.impfdatum')
        public onChangeImpfdatum(date: string | null): void {
            this.impfdatumFormatted = this.formatDate(this.data.impfdatum);

            if (date !== null && this.isNew) {
                this.impfdatumErrorMessages = [];

                for (const rule of [this.rules.required, this.rules.validDate]) {
                    const valid = rule(this.data.impfdatum);
                    if (valid !== true) {
                        this.impfdatumErrorMessages.push(valid as string);
                    }
                }

                if (this.data.impfdatum && (this.data.impfdatum > moment().format('YYYY-MM-DD'))) {
                    this.impfdatumErrorMessages.push('Datum darf nicht in der Zukunft sein.');
                }

                if (this.data.diagnose) {
                    this.data.diagnose.diagnosedatum = this.data.impfdatum;
                }
            }
        }

        get diagnosenFiltered() {
            var retval:any [] = [];
            _.forEach(this.diagnosen, (item: Diagnose) => {
                if (item.diagnose_id !== this.data.diagnose.diagnose_id) {
                    retval.push(item);
                }
            });

            return retval;
        }

        public onClickAdd() {
            this.diagnose = new Diagnose();
            this.setDialogsDetail(true);
        }

        public onClickClose(): void {
            this.setDialogsDetail(false);
        }
    }
